// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"128":"cb4351ce","688":"59c2ce19"}[chunkId] + ".chunk.js";
};